// extracted by mini-css-extract-plugin
export default {"importanceWrapper":"importance_importanceWrapper__NNOeY","redDot":"importance_redDot__eK-5j","yellowDot":"importance_yellowDot__7rL65"};